import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { createI13nNode } from '@vzmi/ec-react-i13n'
import { compose } from 'recompose'
import CommonPage from '../../../../containers/Proposal/Common/CommonPage'
import { withI13nWrapper } from '../../../Common/I13nWrapper'
import Privilege from '../../../Common/Privilege'
import Steps from './Steps'
import Tips from './Tips'
import styles from './index.css'
import CloneNotes from './CloneNotes'

/**
 * External Listing Clone component
 * Multi-step component for cloning external listings
 */
const ExternalListingClone = ({ page, i13nMethods, i13n }) => {
  useEffect(() => {
    i13nMethods.sendI13nPageViewByPageKey('externalClone')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <CommonPage>
      <Privilege page={page}>
        <div className={styles.container}>
          <Tips />
          <Steps i13n={i13n} />
          <CloneNotes />
        </div>
      </Privilege>
    </CommonPage>
  )
}

ExternalListingClone.propTypes = {
  page: PropTypes.object,
  i13nMethods: PropTypes.object,
  i13n: PropTypes.object
}

const hoc = compose(
  createI13nNode,
  withI13nWrapper
)

export default hoc(ExternalListingClone)
